import { referenceCanMovePast } from '@/utils/referenceCanMovePast.js'

/**
 * Campos para merge al padre al devolver unidades del hijo (can_move_past).
 * Fuente única para vistas y store (evita divergencia con lógica duplicada).
 *
 * @param {Object|null|undefined} productRef - Producto desde getProducts(reference_id)
 * @param {Object|null|undefined} childData - timer.data del hijo
 * @param {boolean} todasLasUnidadesDelHijoDevueltas - si en esta operación se devuelven todas las unidades del hijo al padre
 * @returns {Record<string, number|string>}
 */
export function buildCaducidadSnapshotsForParentFromChild (productRef, childData, todasLasUnidadesDelHijoDevueltas) {
    const snap = {}
    if (!todasLasUnidadesDelHijoDevueltas) {
        return snap
    }
    if (!childData || !productRef || !referenceCanMovePast(productRef)) {
        return snap
    }
    const ult = childData.caducidad_ultimo_estado_timestamp
    if (ult != null && ult !== '') {
        snap.caducidad_ultimo_estado_timestamp = ult
    }
    const ini = childData.caducidad_estado_inicial_timestamp
    if (ini != null && ini !== '') {
        snap.caducidad_estado_inicial_timestamp = ini
    }
    return snap
}
